<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Library"
                   :links="[{title:'Home', url:'/'},{title:'Library',url:'/about'},{title:'Resources'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="3"></sidebar>
        </section>
        <section class="content space-y-4">
          <div class="heading-black1">Books and Journals</div>
          <div>
            <table class="min-w-full leading-normal">
              <thead >
              <tr>
                <th rowspan="2" class="table-header">#</th>
                <th rowspan="2" class="table-header">Branch/Course</th>
                <th colspan="2" class="table-header">UG</th>
                <th colspan="2" class="table-header">PG</th>
                <th colspan="2" class="table-header">Total</th>
              </tr>
              <tr>
                <th class="table-header">Tiles</th>
                <th class="table-header">Volumes</th>
                <th class="table-header">Titles</th>
                <th class="table-header">Volumes</th>
                <th class="table-header">Titles</th>
                <th class="table-header">Volumes</th>
              </tr>
              </thead>
              <tbody class="font-semibold text-gray-600">
              <tr v-for="(branch,index) in departments" :key="index">
                <td class="data-row">{{ branch.no }}</td>
                <td class="data-row">{{ branch.branch }}</td>
                <td class="data-row">{{ branch.ugt }}5</td>
                <td class="data-row">{{ branch.ugv }}</td>
                <td class="data-row">{{ branch.pgt }}</td>
                <td class="data-row">{{ branch.pgv }}</td>
                <td class="data-row">{{ branch.tt }}</td>
                <td class="data-row">{{ branch.tv }}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="space-y-4">
            <p class="text-md font-normal text-gray-700">
              The Central Library has a rich collection of Books, Reference books, Handbooks, Indian and International
              journals and non-book materials. The total collection of library is as follows:-</p>
            <div class="text-xl font-semibold uppercase font-serif">Journals List</div>
            <TabView ref="tabview">
              <TabPanel header="UG">
                <Accordion>
                  <AccordionTab header="Mechanical">
                    <DataTable :value="getResult('MechanicalUG')" :rowHover="true">
                      <Column field="no" header="Sr.No."></Column>
                      <Column field="name" class="hover:text-pink-600" header="Name of Journal"></Column>
                    </DataTable>
                  </AccordionTab>
                  <AccordionTab header="Electrical">
                    <DataTable :value="getResult('ElectricalUG')" :rowHover="true">
                      <Column field="no" header="Sr.No."></Column>
                      <Column field="name" class="hover:text-pink-600" header="Name of Journal"></Column>
                    </DataTable>
                  </AccordionTab>
                </Accordion>
              </TabPanel>
              <TabPanel header="PG">
                <Accordion>
                  <AccordionTab header="Mechanical">
                    <DataTable :value="getResult('MechanicalPG')" :rowHover="true">
                      <Column field="no" header="Sr.No."></Column>
                      <Column field="name" class="hover:text-pink-600" header="Name of Journal"></Column>
                    </DataTable>
                  </AccordionTab>
                </Accordion>
              </TabPanel>
            </TabView>
          </div>
        </section>
      </div>
      <programmes></programmes>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/library/Sidebar";
import Programmes from "@/views/about/Programmes";
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';

export default {
  name: "Resources",
  components: {
    Programmes, DataTable, Column,
    NavbarComponent,
    PageHeader,
    Sidebar, TabView,
    TabPanel,
    FooterComponent, Accordion,
    AccordionTab,
  },

  data() {
    return {
      departments: [{
        no: 1,
        branch: 'Mechanical',
        ugt: 475,
        ugv: 3151,
        pgt: 252,
        pgv: 555,
        tt: 727,
        tv: 3706,
      },
        {
          no: 2,
          branch: 'Electrical',
          ugt: 525,
          ugv: 2925,
          pgt: 125,
          pgv: 200,
          tt: 650,
          tv: 3125
        },
        {
          no: 3,
          branch: 'Civil',
          ugt: 316,
          ugv: 2025,
          pgt: 124,
          pgv: 198,
          tt: 440,
          tv: 2223
        },
        {
          no: 4,
          branch: 'Computer',
          ugt: 515,
          ugv: 2121,
          pgt: 121,
          pgv: 125,
          tt: 636,
          tv: 2246
        },
        {
          no: 5,
          branch: 'IT',
          ugt: 216,
          ugv: 978,
          pgt: '-',
          pgv: '-',
          tt: 216,
          tv: 978
        },
        {
          no: 6,
          branch: 'E & TC',
          ugt: 250,
          ugv: 1280,
          pgt: '-',
          pgv: '-',
          tt: 250,
          tv: 1280
        },
        {
          no: 7,
          branch: 'MBA',
          ugt: 1300,
          ugv: 6000,
          pgt: '-',
          pgv: '-',
          tt: 1300,
          tv: 6000
        },
        {
          no: 8,
          branch: 'General Books',
          ugt: 400,
          ugv: 598,
          pgt: '-',
          pgv: '-',
          tt: 400,
          tv: 598
        },
        {
          no: null,
          branch: 'Total',
          ugt: 3997,
          ugv: 19298,
          pgt: 622,
          pgv: 1078,
          tt: 4619,
          tv: 20156
        }],
      Newspapers: [
        {
          no: 1,
          name: 'Sakal ( Marathi)'
        },
        {
          no: 2,
          name: 'Lokmat ( Marathi)'
        },
        {
          no: 3,
          name: 'Divya Marathi'
        },
        {
          no: 4,
          name: 'Loksatta ( Marathi)'
        },
        {
          no: 5,
          name: 'The Indian Express (English)'
        },
        {
          no: 6,
          name: 'The Times Of India ( English )'
        },
        {
          no: 7,
          name: 'Navbharat (Hindi)'
        },

      ],
      Journals: [
        {
          branch: 'MechanicalUG',
          journalsList: [
            {
              no: 1,
              name: 'International Journal of Advanced Manufacturing System',
            },
            {
              no: 2,
              name: 'International Journal of Advanced in Thermal Sciences & Engineering'
            },
            {
              no: 3,
              name: 'International Journal of Advances in  Mechanical Engg'
            }, {
              no: 4,
              name: 'International journal of Fluid Mechanics'
            }, {
              no: 5,
              name: 'International Journal of Manufacturing Science & Technology'
            }, {
              no: 6,
              name: 'International Journal of Manufacturing Technology & Industrial Engg'
            }, {
              no: 7,
              name: 'International Journal of Materials Science & Engg'
            }, {
              no: 8,
              name: 'International Journal of Mechanical Engg'
            }, {
              no: 9,
              name: 'International Journal of Product Design'
            }, {
              no: 10,
              name: 'Journal Of Metallurgical Engineering'
            }, {
              no: 11,
              name: 'Journal of Modern Manufacturing Technology'
            }, {
              no: 12,
              name: 'Indian Journal of Advances and Applications in Fluid Mechanics'
            }, {
              no: 13,
              name: 'Indian Journal of Heat & Mass Transfer'
            }, {
              no: 14,
              name: 'Indian Journal of Manufacturing Systems Research'
            }, {
              no: 15,
              name: 'International Journal of Advanced Mechatronic Systems Research'
            },
            {
              no: 16,
              name: 'EP Journal of Heat and Mass Transfer'
            },

            {
              no: 17,
              name: 'Indian Journal of Mechanical and Thermal Engineering'
            },

            {
              no: 18,
              name: 'Journal on Fluid Mechanics and Engineering'
            },

            {
              no: 19,
              name: 'International Journal of Thermal Engineering (IJTE)'
            },

            {
              no: 20,
              name: 'Journal of Solar Energy'
            },

            {
              no: 21,
              name: 'Journal of Automobile Technology'
            },

            {
              no: 22,
              name: 'Journal of Manufacturing Technology Research and Development (JMTRD)'
            },

            {
              no: 23,
              name: 'International Journal of I.C. Engines and Gas Turbines'
            },
            {
              no: 24,
              name: 'Journal of Refrigeration, Air Conditioning, Heating and Ventilation'
            },


          ],
        },
        {
          branch: 'MechanicalPG',
          journalsList: [
            {
              no: 1,
              name: 'Journal of Materials Science'
            },
            {
              no: 2,
              name: 'Journal of Industrial Engineering and Research'
            },
            {
              no: 3,
              name: 'International Journal of Design and Manufacturing Technology (IJDMT)'
            },
            {
              no: 4,
              name: 'Journal Of Machine Design'
            },
            {
              no: 5,
              name: 'Journal of Mechatronics & Automation'
            },
          ]
        },
        {
          branch: 'ElectricalUG',
          journalsList: [
            {
              no: 1,
              name: 'International Journal of Material Science & Electronic Research'
            },
            {
              no: 2,
              name: 'International Journal of Innovations in Electrical Power System'
            },
            {
              no: 3,
              name: 'International Journal of Highly Reliable Electronic Systems'
            },
            {
              no: 4,
              name: 'International Journal Of Control Theory & Applications(IJCTA)'
            },
            {
              no: 5,
              name: 'International Journal of Integrated Energy Systems'
            },
            {
              no: 6,
              name: 'International Journal of Material Research ,Electronics & Electrical System'
            },
            {
              no: 7,
              name: 'International Journal of Nanomaterials & Technology(IJONMAT)'
            },
            {
              no: 8,
              name: 'International Journal of Power Engineering & Green Technology'
            },
            {
              no: 9,
              name: 'International Journal of Electrical and Electronics Engineering Research'
            },
            {
              no: 10,
              name: 'International Journal of Electrical Engineering & Technology (IJEET)'
            },
            {
              no: 11,
              name: 'Journal of Electrical Machines'
            },
            {
              no: 12,
              name: 'Journal of Electrical and Electronics Engineering Research & Development'
            },
            {
              no: 13,
              name: 'Trends in Electrical Engineering'
            },
            {
              no: 14,
              name: 'International Journal of Electrical Machines & Drives'
            },
            {
              no: 15,
              name: 'International Journal of Electrical Power System and Technology'
            }, {
              no: 16,
              name: 'International Journal of Analysis of Electrical Machines'
            },
            {
              no: 17,
              name: 'Journal of Advance Research in Electrical Engineering and Technology'
            },
            {
              no: 18,
              name: 'Journal of Power System Research and Development'
            },


          ]
        }],
    }
  },
  methods: {
    getResult(branch) {

      const s = this.Journals.filter(item => {
        return item.branch === branch
      });

      const result = JSON.parse(JSON.stringify(s))
      // console.log(result[0].students)
      return result[0].journalsList;
    }
  }
}
</script>
<style lang="scss" scoped>
p {
  margin-bottom: 0.6rem;
}

::v-deep(.p-datatable) {
  .p-datatable-header {
    background: #e6e6e6;
    color: #404040;
  }

  .p-datatable-thead > tr > th {
    background: #e6e6e6;
    color: #404040;
  }
}
</style>
